<div
     snAssistantSurface="newCampaign"
     i18n-surfaceTitle="@@newCampaign.surface"
     surfaceTitle="New campaign" class="outbound-campaign-create-container">
  <!-- Header -->
  <div class="campaign-create-header">
    <div class="title-section">
      <h1 i18n="@@campaignCreate.title">Create New Campaign</h1>
      <p class="subtitle" i18n="@@campaignCreate.subtitle">Set up a new outbound calling campaign</p>
    </div>
  </div>

  <!-- Form -->
  <div class="form-section">
    <p-card>
      <div class="form-content">
        <!-- Campaign Title -->
        <div class="form-field">
          <label class="field-label"><ng-container i18n="@@campaignCreate.name.label">Campaign Title</ng-container> *</label>
          <p class="field-description" i18n="@@campaignCreate.name.description">Give your campaign a descriptive title</p>
          <input
            pInputText
            name="campaign_name"
              [(ngModel)]="campaignTitle"
            i18n-placeholder="@@campaignCreate.name.placeholder"
            placeholder="e.g., Customer Outreach Q1 2024"
            class="w-full"
            [disabled]="isCreating">
        </div>

        <!-- Agent Selection -->
        <div class="form-field">
          <label class="field-label"><ng-container i18n="@@conversations.filter.agent">Agent</ng-container> *</label>
          <p class="field-description" i18n="@@campaignCreate.agent.description">Select the agent to use for outbound calls</p>
          <p-select
            name="agent_id"
              [(ngModel)]="selectedAgentId"
            [options]="agentOptions"
            optionLabel="label"
            optionValue="value"
            i18n-placeholder="@@phoneNumberEdit.selectAgent"
            placeholder="Select an agent"
            [disabled]="isCreating"
            class="w-full">
          </p-select>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <p-button
            i18n-label="@@common.cancel"
            label="Cancel"
            severity="secondary"
            [outlined]="true"
            (click)="onCancel()"
            [disabled]="isCreating">
          </p-button>
          <p-button
            i18n-label="@@campaignCreate.submit"
            label="Create Campaign"
            icon="pi pi-check"
            (click)="onCreate()"
            [disabled]="!campaignTitle.trim() || !selectedAgentId || isCreating"
            [loading]="isCreating"
            snAssistantAction="create"
            actionHint="Creates the campaign and opens it. Contacts are added on the next screen; nobody is called until the campaign is started.">
          </p-button>
        </div>
      </div>
    </p-card>
  </div>
</div>
